import {
	SETMETTINGVIPSTORES
} from './mutation-types.js'

export default {
	[SETMETTINGVIPSTORES](state, stores) {
		state.stores = stores;
	},
}
